import { englishTranslations } from './english';
import { chineseTranslations } from './chinese';
import { japaneseTranslations } from './japanese';
import { koreanTranslations } from './korean';

export const translations = {
  English: englishTranslations,
  Chinese: chineseTranslations,
  Japanese: japaneseTranslations,
  Korean: koreanTranslations,
};

export const getTranslation = (language, path) => {
  const keys = path.split('.');
  let result = translations[language];
  
  for (const key of keys) {
    if (result && typeof result === 'object') {
      result = result[key];
    } else {
      // Fallback to English if translation not found
      result = translations['English'];
      for (const fallbackKey of keys) {
        if (result && typeof result === 'object') {
          result = result[fallbackKey];
        } else {
          return path; // Return the path if nothing is found
        }
      }
      break;
    }
  }
  
  return result || path;
};